import React from "react";
import ActionsPopup from "../ActionsPopup";
import schema from "../ActionsPopup/agent_attorney_individs_actions";
import cellGenerator from "./columnUtils";

const agent_attorney_individs_columns = (isSubaccount) => [
  {
    Header: "Profile Name",
    accessor: "AgentFormData.new_profile_individual_agent_profile_name",
    Cell: (props) => cellGenerator(props),
  },
  {
    Header: "Last Name",
    accessor: "AgentFormData.new_profile_individual_agent_last_name",
    Cell: (props) => cellGenerator(props),
  },
  {
    Header: "First Name",
    accessor: "AgentFormData.new_profile_individual_agent_first_name",
    Cell: (props) => cellGenerator(props),
  },
  {
    Header: "Agent or Attorney",
    accessor: "AgentFormData.new_profile_individual_agent_type_id",
    Cell: ({ value }) => <span className="cell">{value}</span>,
  },
  {
    id: "actions",
    Header: "Actions",
    accessor: (d) => d,
    fixedWidth: 130,
    disableSortBy: true,
    isButton: true, // removes padding and positioning
    Cell: ({ row: { original } }) => (
      <ActionsPopup
        actionsPopupSchema={schema("agent-attorney-individs", isSubaccount)}
        id={original.id}
      />
    ),
  },
];

export default agent_attorney_individs_columns;
